import React, {useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {Bottom, Top, Logo, LinkButton, RiveFetch} from "parts";
import {existsTranslation, setProfile, setRegister, setStep, setTrack} from "utils";
import {useTranslation} from 'react-i18next';

export function Start({step, toAdd, nextUrl, preload}) {
  const
    {t, i18n} = useTranslation('common', {keyPrefix: 'start'}),
    [searchParams] = useSearchParams()

  const
    utm = searchParams.get('utm_content'),
    id = `mapping.` + (utm || '')

  const utmText = t(existsTranslation(i18n, `start.${id}`) ? id : 'h1')

  useEffect(() => {
    if (utm) {
      console.log('utm', utm, utmText)
      setRegister({
        utm_content: utm,
      })
    }

    if (searchParams.get('utm_creative')) {
      setRegister({
        utm_creative: searchParams.get('utm_creative'),
      })
      setProfile({
        utm_creative: searchParams.get('utm_creative')
      })
    }

    setStep(step, toAdd)

    window.localStorage.removeItem('success')
    window.localStorage.setItem('utm', utmText?.replace(/<br>/g, ' '))
  }, [])

  return (
    <div className={'wrap fixed'}>
      <Top className={'pb-0'} style={{justifyContent: 'space-between'}}>
        <Logo/>

        <RiveFetch width={390} height={260} show={false} className={'w-100'}
                   src={'welcome.riv'} module={true}
                   stateMachines={'state-machine'}
                   inputName={'Active'} value={true}
        />

        <div className={'stack gap-4 text-start'}>
          <h1 className={'w-100 pre-line'}>{utmText}</h1>
          <p className={'w-100 small'}>{t('desc')}</p>
          <p className={'w-100 notice md mb-2'}>{t('notice')}</p>
        </div>

        <LinkButton to={nextUrl} onClick={() => setTrack('start quiz')}>{t('btn')}</LinkButton>

        <p/>
      </Top>

      <Bottom preload={preload}/>
    </div>
  )
}